import EventLog from '@/ts/instances/notifications/EventLog';

export default class LogNotification {
    public id: number;
    public title: string;
    public text: string;
    public seen: boolean;
    public createdAt: string;

    public author: any;
    public eventLog: EventLog;

    constructor(
        id: number,
        title: string,
        text: string,
        seen: boolean,
        createdAt: string,
        eventLog: EventLog,
    ) {
        this.id        = id;
        this.title     = title;
        this.text      = text;
        this.seen      = seen;
        this.createdAt = createdAt;
        this.eventLog  = eventLog;
    }

    get authorName(): string {
        return this.author.firstName + ' ' + this.author.lastName;
    }

    get initials(): string {
        return `${this.author.firstName.charAt(0)}${this.author.lastName.charAt(0)}`;
    }

    public setAuthor(author: any) {
        this.author = author;
    }

    public read() {
        this.seen = true;
    }
}
